// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_PS5","cls2":"ImpactHubModal-cls2_8-O ImpactHubModal-cls1_PS5"};